import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { styled, Button, MenuItem, Theme, useTheme } from '@material-ui/core';
import { LinkTarget } from '../../../shared/types';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIcon } from 'src/config/api/models/FontAwesome';

type Props = {
  onClick?: (event: React.MouseEvent<EventTarget>) => void;
  to?: string;
  target?: LinkTarget;
  label: string;
  icon: SpriteIcon;
  id?: string;
  className?: string;
  isDisabled?: boolean;
};

const StyledMenuItemWrapper = styled('div')<Theme>(({ theme }) => ({
  padding: '0 1rem',
  cursor: 'pointer',
  '&:not(:last-child) :is(a, button)': {
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    width: '100%',
  },
  '& :is(a, .MuiButton-label)': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    gap: '1rem',
  },
  '& .MuiMenuItem-root': {
    fontFamily: theme.config.secondaryFontFamily,
    fontSize: theme.typography.bodyLg.fontSize,
    padding: theme.spacing(2),
    transition: theme.config.defaultTransition,
    '&:hover': {
      background: theme.palette.grey['100'],
    },
  },
}));

const StyledMenuItemButton = styled(Button)({
  width: '100%',
  borderRadius: 0,
});

const StyledMenuItemLabel = styled('span')<Theme, { isDisabled: boolean }>(({ isDisabled }) => ({
  textTransform: 'none',
  opacity: isDisabled ? 0.5 : 1,
}));

const UserMenuListItem: FC<Props> = ({
  onClick,
  to,
  target = '_self',
  label,
  icon,
  id,
  className,
  isDisabled = false,
}) => {
  const theme = useTheme();
  return (
    <StyledMenuItemWrapper className={`border ${className ?? ''}`} id={id}>
      <MenuItem
        component={to ? Link : StyledMenuItemButton}
        to={to}
        target={target}
        onClick={onClick}
      >
        <FontAwesomeSpriteIcon
          icon={icon}
          iconSize="lg"
          color={theme.palette.grey[900]}
          isDisabled={isDisabled}
        />
        <StyledMenuItemLabel isDisabled={isDisabled}>{label}</StyledMenuItemLabel>
      </MenuItem>
    </StyledMenuItemWrapper>
  );
};

export default UserMenuListItem;
